/* eslint-disable */
import { request } from '@umijs/max'

// 12602-新增或更新菜单 POST /web/v1/menu/upsert
export async function upsertMenu(body: any, options?: { [key: string]: any }) {
  return request<any>('/web/v1/menu/upsert', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: body,
    ...(options || {}),
  })
}

// 菜单列表（树或平铺，按顺序） GET /web/v1/menu/list
export async function getMenuList(options?: { [key: string]: any }) {
  return request<any>('/web/v1/menu/list', {
    method: 'GET',
    ...(options || {}),
  })
}

// 菜单详情 GET /web/v1/menu/detail/{id}
export async function getMenuDetail(params: { id: string | number }, options?: { [key: string]: any }) {
  const { id, ...rest } = params
  return request<any>(`/web/v1/menu/detail/${id}`, {
    method: 'GET',
    params: { ...rest },
    ...(options || {}),
  })
}

// 菜单删除 GET /web/v1/menu/delete/{id}
export async function deleteMenu(params: { id: string | number }, options?: { [key: string]: any }) {
  const { id, ...rest } = params
  return request<any>(`/web/v1/menu/delete/${id}`, {
    method: 'GET',
    params: { ...rest },
    ...(options || {}),
  })
}

// 菜单状态变更 POST /web/v1/menu/status/{id}
export async function updateMenuStatus(params: { id: string | number; status: number }, options?: { [key: string]: any }) {
  const { id, ...rest } = params
  return request<any>(`/web/v1/menu/status/${id}`, {
    method: 'POST',
    params: { ...rest },
    ...(options || {}),
  })
}


